import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const usePackagerNames = () => {
  const [packagers, setPackagers] = useState([]);

  useEffect(() => {
    axios.get(`${API}/packagers/names`).then((res) => setPackagers(res.data)).catch(() => setPackagers([]));
  }, []);

  return packagers;
};
